import { Type } from '@angular/core';
import { UnicEffectsAvailableEnum } from '../modules/dynamic-effects/deletable-effect-sources.constant';
import { IEffect } from '../modules/dynamic-effects/effect.interface';
import { JobsiteLoadAddressEffects as JobsiteLoadAddressLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-address.effects';
import { JobsiteLoadAddressModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-address.effects';
import { PurchaseOrderRMSMandatoryEffects } from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/effects/purchase-order-effects/purchase-order-mandatory.effects';
import { PurchaseOrderMandatoryEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/purchase-order-effects/purchase-order-mandatory.effects';
import { JobsitePlantDefaultEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-plant-effects/jobsite-plant-default.effects';
import { JobsitePlantEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-plant-effects/jobsite-plant.effects';
import { JobsiteRadiusRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-render-map-effects/jobsite-radius-render-map.effects';
import { JobsiteRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { PointOfDeliveryRadiusRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-radius-render-map.effects';
import { PointOfDeliveryRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-render-map.effects';
import { ReceivingPersonsCustomerLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/receiving-persons/receiving-person-load-effects/receiving-person-customer-load.effects';
import { AlternativeUnitsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/alternative-units.effects';
import { UnitsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/units.effects';
import { ReceivingPersonsLoadEffects } from '../modules/receiving-person/redux/effects/receiving-person-load.effects';
import { TimeWindowsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/time-windows.effects';
import { TimeWindowsFromPlantEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/time-windows-form-plant.effects';
import { ProductLoadEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/product-effects/product-load-effects/product-load.effects';
import {
  AddedValuesNotFormulatingFactory,
  AddedValuesNotFormulatingOpenPlatformFactory,
  AddedValuesOpenPlatformFactory,
  AdtContractsFactory,
  AdtPaymentTermsFactory,
  AdtProductsFactory,
  AdtUnitsFactory,
  AlternativeUnitsFactory,
  AnticipatedInvoiceLoadFactory,
  CalendarsFactory,
  ContractBalanceFactory,
  ContractFactory,
  CutOffFactory,
  ExperiencesLoadFactory,
  factoryEffectFn,
  JobsiteLoadAddressFactory,
  JobsiteLoadAddressLocSpecFactory,
  JobsiteLoadAddressModifyFactory,
  JobsiteLoadExperienceCompleteFactory,
  JobsiteLoadExperienceFactory,
  JobsiteLoadExperienceModifyFactory,
  JobsiteLoadFactory,
  JobsiteLoadFullSalesAreaFactory,
  JobsiteLoadLocSpecFactory,
  JobsiteLoadModifyFactory,
  JobsiteLoadModifyWithMaskFactory,
  JobsiteLoadSalesAreaFactory,
  JobsiteLoadSalesAreasFactory,
  JobsiteLoadSalesAreaWithoutPlantFactory,
  JobsiteNoShippingConditionLoadFactory,
  JobsitePlantDefaultFactory,
  JobsitePlantFactory,
  JobsiteRadiusRenderMapFactory,
  JobsiteRenderMapFactory,
  JobsiteStdLotFactory,
  JobsiteWithoutDocumentsLoadFactory,
  LoadHolidaysFactory,
  MinLotFactory,
  NewReceivingPersonFactory,
  NextWorkingDayFactory,
  OneCLickAlternativeUnitsBuilderFactory,
  OneCLickAlternativeUnitsFactory,
  OneClickBuilderPaymentsFactory,
  OneClickContractFactory,
  OneClickHaulersFactory,
  OneClickHolidaysFactory,
  OneClickJobsiteSalesAreaFromOrderFactory,
  OneClickJobsitesFactory,
  OneClickNextWorkingDayFactory,
  OneClickOwnFreightPlantsFactory,
  OneClickPaymentsFactory,
  OneClickPlantsFactory,
  OneClickPointOfDeliveriesFactory,
  OneClickProfileFactory,
  OneClickReceivingPersonFactory,
  OneClickRegionPlantsFactory,
  OneClickSalesAreaErrorFactory,
  OneClickStandardLotFactory,
  OneClickTimeWindowsFactory,
  PaymentTermsFactory,
  PODLoadFactory,
  PointOfDeliveryLoadAddressFactory,
  PointOfDeliveryLoadAddressNewPODFactory,
  PointOfDeliveryLoadFactory,
  PointOfDeliveryLoadSalesAreaFactory,
  PointOfDeliveryRadiusRenderMapFactory,
  PointOfDeliveryRenderMapFactory,
  ProductExperienceLoadFactory,
  ProductLoadFactory,
  ProductLoadLocSpecFactory,
  ProductPlantsFactory,
  ProductsOpenPlatformFactory,
  PurchaseOrderMandatoryFactory,
  PurchaseOrderMaskModifyFactory,
  PurchaseOrderRMSMandatoryFactory,
  ReceivingPersonsCustomerLoadFactory,
  ReceivingPersonsLoadFactory,
  RmsColombiaProductsFactory,
  RmsContractProductsFactory,
  SimulateFactory,
  SimulateOPFactory,
  SingleCatalogsFactory,
  TimeWindowsFactory,
  TimeWindowsFromPlantFactory,
  TimeWindowsFromPlantLocationSpecificationFactory,
  TopProductsFactory,
  TopProductsULinkFactory,
  UnitsFactory,
  V1OfmNextWorkingDayFactory,
  VehiclesFactory,
} from './factory-effect';
import { JobsiteLoadAddressEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteLoadSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { JobsiteLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { RmsContractProductsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/contract-products.effects';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { AddedValuesNotFormulatingEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/added-values.effects-not-formulating';
import { AddedValuesNotFormulatingOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/addded-values.effects-not-formulating-op';
import { CutOffEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/cut-off.effects';
import { SingleCatalogsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/single-catalogs.effects';
import { JobsiteLoadModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { JobsiteLoadModifyWithMaskEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load-mask.effects';
import { JobsiteLoadExperienceModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-experience.effects';
import { JobsiteLoadSalesAreasEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-salesareas.effect';
import { PurchaseOrderMaskModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/purchase-order-mask.effect';
import { SimulateEffects } from '@ordersnproducts/modules/order-builder/modules/rms-summary/effects/simulate.effects';
import { PointOfDeliveryLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-effects/point-of-delivery-load.effects';
import { PointOfDeliveryLoadAddressEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address.effects';
import { AdtProductsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/products.effects';
import { AdtContractsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/contracts.effects';
import { AdtUnitsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/units.effects';
import { AdtPaymentTermsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/paymet-terms.effects';
import { PointOfDeliveryLoadSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-sales-area/point-of-delivery-load-sales-area.effects';
import { PointOfDeliveryLoadAddressNewPODEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address-newpod.effects';
import { JobsiteLoadFullSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-full-sales-area.effects';
import { CalendarsEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/calendar-effects/calendars.effects';
import { JobsiteStdLotEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobiste-std-lot-effects/jobsite-std-lot.effects';
import { JobsiteLoadSalesAreaWithoutPlantEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-sales-area-without-plant.effects';
import { JobsiteWithoutDocumentsLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load-without-documents.effects';
import { JobsiteNoShippingConditionLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load-no-shipping-condition.effects';
import { ExperiencesLoadEffect } from '@ordersnproducts/modules/order-builder/modules/location/effects/experiences-effects/experiences-load.effect';
import { ContractEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract.effects';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { NextWorkingDayEffect } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/next-working-day.effects';
import { VehiclesEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/vehicle.effects';
import { ProductPlantsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/product-plants.effects';
import { V1OfmNextWorkingDayEffects } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/v1-ofm-next-working-day.effects';
import {
  TopProductsEffects,
  TopProductsULinkEffects,
} from '@ordersnproducts/modules/order-builder/modules/retail-specification/effects/top-products.effects';
import { MinLotEffects } from '@ordersnproducts/modules/order-builder/modules/retail-specification/effects/min-lot.effects';
import { PaymentTermsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/payment-terms.effects';
import { LoadHolidaysEffect } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/load-holidays.effects';
import { SimulateOPEffects } from '@ordersnproducts/modules/order-builder/modules/rms-summary/effects/open-platform/simulate-op.effects';
import { AddedValuesOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/addded-values.effects';
import { PODLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/pod-load-effects/point-of-delivery-load.effects';
import { JobsiteLoadExperienceCompleteEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-experience-complete.effects';
import { JobsiteLoadExperienceEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-experience.effects';
import { ProductExperienceLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/product-effects/product-load-effects/product-experience-load.effects';
import { ProductLoadEffects as ProductLoadLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/product-effects/product-load-effects/product-load.effects';
import { JobsiteLoadLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { NewReceivingPersonEffects } from '../modules/receiving-person/redux/effects/new-receiving-person.effects';
import { AnticipatedInvoiceLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/anticipated-invoice-effects/anticipated-invoice-load-effects/anticipated-invoice-load.effects';
import { OneClickSalesAreaErrorEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-sales-area-error.effects';
import { OneCLickAlternativeUnitsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units.effects';
import { OneClickNextWorkingDayEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-next-working-day-services.effects';
import { OneClickHolidaysEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-holidays.effects';
import { OneClickOwnFreightPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-ownFreight-plants.effects';
import { OneClickHaulersEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-hauler.effect';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickReceivingPersonEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-receiving-person.effects';
import { OneClickStandardLotEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-standard-lot.effects';
import { OneClickTimeWindowsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-time-windows.effects';
import { OneClickPaymentsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-payments.effects';
import { OneCLickAlternativeUnitsBuilderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units-builder.effects';
import { OneClickRegionPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-region-plants.effects';
import { OneClickPointOfDeliveriesEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-pods.effects';
import { OneClickPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-plants.effects';
import { OneClickBuilderPaymentsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-payment-builder.effects';
import { OneClickProfileEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-profile.effects';
import { OneClickJobsitesEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsites.effects';
import { RmsColombiaProductsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/colombia-products.effects';
import { TimeWindowsFromPlantLocationSpecificationEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/location-specification-form/time-windows-form-plant.effects';

/**
 * List of similar effects pair that receive the same action,
 * and store response of different APIs in the same store module.
 */
export const EffectsListInitRecord: Partial<Record<UnicEffectsAvailableEnum, Type<IEffect>>> = {
  [UnicEffectsAvailableEnum.JobsiteLoadAddressEffects]: JobsiteLoadAddressLocSpecEffects,
  [UnicEffectsAvailableEnum.JobsiteLoadAddressModifyEffects]: JobsiteLoadAddressModifyEffects,
  [UnicEffectsAvailableEnum.PurchaseOrderRMSMandatoryEffects]: PurchaseOrderRMSMandatoryEffects,
  [UnicEffectsAvailableEnum.PurchaseOrderMandatoryEffects]: PurchaseOrderMandatoryEffects,
  [UnicEffectsAvailableEnum.JobsitePlantDefaultEffects]: JobsitePlantDefaultEffects,
  [UnicEffectsAvailableEnum.JobsitePlantEffects]: JobsitePlantEffects,
  [UnicEffectsAvailableEnum.JobsiteRadiusRenderMapEffects]: JobsiteRadiusRenderMapEffects,
  [UnicEffectsAvailableEnum.JobsiteRenderMapEffects]: JobsiteRenderMapEffects,
  [UnicEffectsAvailableEnum.PointOfDeliveryRadiusRenderMapEffects]: PointOfDeliveryRadiusRenderMapEffects,
  [UnicEffectsAvailableEnum.PointOfDeliveryRenderMapEffects]: PointOfDeliveryRenderMapEffects,
  [UnicEffectsAvailableEnum.ReceivingPersonsCustomerLoadEffects]: ReceivingPersonsCustomerLoadEffects,
  [UnicEffectsAvailableEnum.AlternativeUnitsEffects]: AlternativeUnitsEffects,
  [UnicEffectsAvailableEnum.UnitsEffects]: UnitsEffects,
  [UnicEffectsAvailableEnum.ReceivingPersonsLoadEffects]: ReceivingPersonsLoadEffects,
  [UnicEffectsAvailableEnum.TimeWindowsEffects]: TimeWindowsEffects,
  [UnicEffectsAvailableEnum.TimeWindowsFromPlantEffects]: TimeWindowsFromPlantEffects,
};

export interface EffectsList {
  [key: string]: string;
}

/**
 * Map of effect class to get its factory function
 */
export const FactoryEffectsFnMap = new Map<Function, factoryEffectFn>([
  [JobsiteLoadEffects, JobsiteLoadFactory],
  [JobsiteRadiusRenderMapEffects, JobsiteRadiusRenderMapFactory],
  [JobsiteLoadAddressEffects, JobsiteLoadAddressFactory],
  [JobsiteLoadAddressLocSpecEffects, JobsiteLoadAddressLocSpecFactory],
  [JobsiteLoadAddressModifyEffects, JobsiteLoadAddressModifyFactory],
  [JobsiteLoadSalesAreaEffects, JobsiteLoadSalesAreaFactory],
  [JobsiteRenderMapEffects, JobsiteRenderMapFactory],
  [RmsContractProductsEffects, RmsContractProductsFactory],
  [ProductsOpenPlatformEffects, ProductsOpenPlatformFactory],
  [AddedValuesNotFormulatingEffects, AddedValuesNotFormulatingFactory],
  [AddedValuesNotFormulatingOpenPlatformEffects, AddedValuesNotFormulatingOpenPlatformFactory],
  [CutOffEffects, CutOffFactory],
  [SingleCatalogsEffects, SingleCatalogsFactory],
  [ReceivingPersonsLoadEffects, ReceivingPersonsLoadFactory],
  [JobsiteLoadModifyEffects, JobsiteLoadModifyFactory],
  [JobsiteLoadModifyWithMaskEffects, JobsiteLoadModifyWithMaskFactory],
  [ProductLoadEffects, ProductLoadFactory],
  [JobsiteLoadExperienceModifyEffects, JobsiteLoadExperienceModifyFactory],
  [JobsiteLoadSalesAreasEffects, JobsiteLoadSalesAreasFactory],
  [PurchaseOrderMaskModifyEffects, PurchaseOrderMaskModifyFactory],
  [SimulateEffects, SimulateFactory],
  [PointOfDeliveryLoadEffects, PointOfDeliveryLoadFactory],
  [PointOfDeliveryLoadAddressEffects, PointOfDeliveryLoadAddressFactory],
  [ReceivingPersonsCustomerLoadEffects, ReceivingPersonsCustomerLoadFactory],
  [JobsitePlantEffects, JobsitePlantFactory],
  [JobsitePlantDefaultEffects, JobsitePlantDefaultFactory],
  [PurchaseOrderRMSMandatoryEffects, PurchaseOrderRMSMandatoryFactory],
  [OneClickJobsitesEffects, OneClickJobsitesFactory],
  [OneClickProfileEffects, OneClickProfileFactory],
  [OneClickBuilderPaymentsEffects, OneClickBuilderPaymentsFactory],
  [OneClickPlantsEffects, OneClickPlantsFactory],
  [OneClickPointOfDeliveriesEffects, OneClickPointOfDeliveriesFactory],
  [OneClickRegionPlantsEffects, OneClickRegionPlantsFactory],
  [OneCLickAlternativeUnitsBuilderEffects, OneCLickAlternativeUnitsBuilderFactory],
  [OneClickPaymentsEffects, OneClickPaymentsFactory],
  [OneClickTimeWindowsEffects, OneClickTimeWindowsFactory],
  [OneClickStandardLotEffects, OneClickStandardLotFactory],
  [OneClickReceivingPersonEffects, OneClickReceivingPersonFactory],
  [OneClickContractEffects, OneClickContractFactory],
  [OneClickJobsiteSalesAreaFromOrderEffects, OneClickJobsiteSalesAreaFromOrderFactory],
  [OneClickHaulersEffects, OneClickHaulersFactory],
  [OneClickOwnFreightPlantsEffects, OneClickOwnFreightPlantsFactory],
  [OneClickHolidaysEffects, OneClickHolidaysFactory],
  [OneClickNextWorkingDayEffects, OneClickNextWorkingDayFactory],
  [OneCLickAlternativeUnitsEffects, OneCLickAlternativeUnitsFactory],
  [OneClickSalesAreaErrorEffects, OneClickSalesAreaErrorFactory],
  [AnticipatedInvoiceLoadEffects, AnticipatedInvoiceLoadFactory],
  [NewReceivingPersonEffects, NewReceivingPersonFactory],
  [JobsiteLoadLocSpecEffects, JobsiteLoadLocSpecFactory],
  [ProductLoadLocSpecEffects, ProductLoadLocSpecFactory],
  [ProductExperienceLoadEffects, ProductExperienceLoadFactory],
  [JobsiteLoadExperienceEffects, JobsiteLoadExperienceFactory],
  [JobsiteLoadExperienceCompleteEffects, JobsiteLoadExperienceCompleteFactory],
  [PODLoadEffects, PODLoadFactory],
  [TimeWindowsFromPlantLocationSpecificationEffects, TimeWindowsFromPlantLocationSpecificationFactory],
  [TimeWindowsFromPlantEffects, TimeWindowsFromPlantFactory],
  [AddedValuesOpenPlatformEffects, AddedValuesOpenPlatformFactory],
  [SimulateOPEffects, SimulateOPFactory],
  [LoadHolidaysEffect, LoadHolidaysFactory],
  [PaymentTermsEffects, PaymentTermsFactory],
  [MinLotEffects, MinLotFactory],
  [TopProductsEffects, TopProductsFactory],
  [TopProductsULinkEffects, TopProductsULinkFactory],
  [V1OfmNextWorkingDayEffects, V1OfmNextWorkingDayFactory],
  [ProductPlantsEffects, ProductPlantsFactory],
  [VehiclesEffects, VehiclesFactory],
  [TimeWindowsEffects, TimeWindowsFactory],
  [NextWorkingDayEffect, NextWorkingDayFactory],
  [ContractBalanceEffects, ContractBalanceFactory],
  [ContractEffects, ContractFactory],
  [AlternativeUnitsEffects, AlternativeUnitsFactory],
  [UnitsEffects, UnitsFactory],
  [ExperiencesLoadEffect, ExperiencesLoadFactory],
  [JobsiteNoShippingConditionLoadEffects, JobsiteNoShippingConditionLoadFactory],
  [JobsiteWithoutDocumentsLoadEffects, JobsiteWithoutDocumentsLoadFactory],
  [JobsiteLoadSalesAreaWithoutPlantEffects, JobsiteLoadSalesAreaWithoutPlantFactory],
  [JobsiteStdLotEffects, JobsiteStdLotFactory],
  [CalendarsEffects, CalendarsFactory],
  [JobsiteLoadFullSalesAreaEffects, JobsiteLoadFullSalesAreaFactory],
  [PointOfDeliveryLoadAddressNewPODEffects, PointOfDeliveryLoadAddressNewPODFactory],
  [PointOfDeliveryRenderMapEffects, PointOfDeliveryRenderMapFactory],
  [PointOfDeliveryRadiusRenderMapEffects, PointOfDeliveryRadiusRenderMapFactory],
  [PointOfDeliveryLoadSalesAreaEffects, PointOfDeliveryLoadSalesAreaFactory],
  [PurchaseOrderMandatoryEffects, PurchaseOrderMandatoryFactory],
  [AdtProductsEffects, AdtProductsFactory],
  [AdtContractsEffects, AdtContractsFactory],
  [AdtUnitsEffects, AdtUnitsFactory],
  [AdtPaymentTermsEffects, AdtPaymentTermsFactory],
  [RmsColombiaProductsEffects, RmsColombiaProductsFactory],
]);
